import { render } from "./notas.vue?vue&type=template&id=03850415"
import script from "./notas.vue?vue&type=script&lang=js"
export * from "./notas.vue?vue&type=script&lang=js"

import "./notas.vue?vue&type=style&index=0&id=03850415&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__